import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function OpeningHook() {
  return <section className="w-full bg-cream-dark py-16 md:py-24 px-6" data-id="element-138">
      <div className="max-w-3xl mx-auto relative" data-id="element-139">
        <FadeIn data-id="element-140">
          <Quote className="w-16 h-16 text-sage opacity-30 absolute -top-8 -left-8 md:-left-12" data-id="element-141" />
          <div className="prose prose-lg md:prose-xl text-slate-800 font-serif leading-relaxed italic relative z-10" data-id="element-142">
            <p className="mb-6" data-id="element-143">
              Estás en la sala y escuchas a tu hijo agobiado en su cuarto.
              Llegas y lo encuentras pálido, temblando, diciendo que no puede
              respirar o que siente que algo horrible va a pasar.
            </p>
            <p className="mb-6" data-id="element-144">
              Le dices que se calme, pero eso solo lo pone peor. No es que no te
              escuche, es que su cerebro entró en modo "supervivencia" y no
              entiende palabras.
            </p>
            <p className="font-bold text-slate-900 not-italic text-xl md:text-2xl mt-8 border-l-4 border-amber pl-6" data-id="element-145">
              Necesitas un interruptor físico, no un discurso motivacional.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}